import React, { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { useHistory } from 'react-router-dom'
import { Form, Row, Col, Button } from 'react-bootstrap'
import { listIssuetype, listRepairType, createService, addImageMaintenance } from '../Network/Repair'
import { uploadFile } from '../Network/Manage'
import { NotifyContext } from '../Library/Notify'
import { AuthContext } from '../Auth/AuthContext'
import { HeaderTitle, Loading } from '../Library'
import "./Inform.css"

function Inform() {
    const notifyCx = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const authCx = useContext(AuthContext)
    const history = useHistory()
    const lang = langCx.lang.service
    const repairLang = langCx.lang.repair_service

    const genderItem = [
        {id: "ห้องน้ำชาย", value: lang.male, label: lang.male},
        {id: "ห้องน้ำหญิง", value: lang.female, label: lang.female},
        {id: "ห้องน้ำคนพิการ", value: lang.disabled, label: lang.disabled}
    ]
    const areaItem = [
        {id: "ห้องน้ำชาย", value: lang.men_toilet, label: lang.men_toilet},
        {id: "ห้องน้ำหญิง", value: lang.female_toilet, label: lang.female_toilet},
        {id: "ห้องน้ำคนพิการ", value: lang.disabled_toilet, label: lang.disabled_toilet},
        {id: "พื้นที่ส่วนกลาง", value: lang.common_area, label: lang.common_area},
        {id: "พื้นที่ส่วนลูกค้า", value: lang.customer_area, label: lang.customer_area}
    ]

    const [isLoading, setLoading] = useState(false)
    const [serviceTypeList, setServiceTypeList] = useState([])
    const [selectServicetype, setSelectServicetype] = useState("")
    const [issueTypeList, setIssuetypeList] = useState([])
    const [selectIssuetype, setSelectIssuetype] = useState("")

    const [area, setArea] = useState("")
    const [quantity, setQuantity] = useState("")
    const [telephone, setTelephone] = useState("")
    const [remark, setRemark] = useState("")
    const [officePhone, setOfficePhone] = useState("")
    const [floor, setFloor] = useState("")
    const [zone, setZone] = useState("")
    const [isError, setError] = useState(false)

    const [selectImages, setSelectImages] = useState([])

    const fetchServiceList = () =>{
        listRepairType(
            (data)=>{
                var serviceType = []
                data.forEach((item)=>{
                    serviceType.push({ value: item.id, label: langCx.code === 'th' ? item.name : item.nameEn })
                })
                setServiceTypeList(serviceType)
            },
            (error)=>{  }
        )
    }

    const fetchIssueType = (repairTypeId) =>{
        listIssuetype(repairTypeId,
            (data)=>{
                var issueType = []
                data.forEach((item)=>{
                    issueType.push({ value: item.id, label: langCx.code === 'th' ? item.name : item.nameEn })
                })
                setIssuetypeList(issueType)
            },
            (error)=>{ })
    }

    const informationNotComplete = () =>{
        notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
        setError(true)
    }

    const onSubmit = () =>{
        if(!selectServicetype || !selectIssuetype || !officePhone || !floor || !zone ){ 
            informationNotComplete()
            return; 
        }
        if(selectIssuetype >= 1 && selectIssuetype <= 4){
            if(!quantity){
                informationNotComplete()
                return;
            }
        }
        if(selectIssuetype === "8"){
            if(!telephone) { 
                informationNotComplete()
                return; 
            }
        }
        if((selectIssuetype >= 14 && selectIssuetype <= 21) || (selectIssuetype >= 25 && selectIssuetype <= 28)){
            if(!area){ 
                informationNotComplete()
                return 
            }
            if(selectIssuetype === "21" || selectIssuetype === "25"){
                if(!quantity){
                    informationNotComplete()
                    return
                }
            }
        }

        setLoading(true)
        createService(selectServicetype, selectIssuetype, area, quantity, telephone, remark, floor, zone, officePhone,
            (data)=>{
                let id = data.id
                
                if(selectImages.length > 0){
                    uploadImage((imagePath)=>{
                        // Add image
                        console.log(imagePath)
                        addImageMaintenance(id, imagePath,
                            ()=>{ 
                                notifyCx.showNotify(lang.sent_complete, lang.sent_complete_desc, 0)
                                history.push("/")
                            },
                            (error)=>{ notifyCx.showNotify("Something wrong add image url ", error.message, 2) })
                    })
                }else{
                    notifyCx.showNotify(lang.sent_complete, lang.sent_complete_desc, 0)
                    history.push("/")
                }

                setLoading(false)
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Something wrong", error.message, 2)
                console.log(error.response)
            })
    }

    const uploadImage = (onFinishUpload) =>{
        var imagePath = []
                
        // Upload image
        for(let i = 0; i < selectImages.length; i++){
            uploadFile(selectImages[i], "maintenance",
            (link)=>{
                imagePath.push({ "imagePath": link })
                if(i === selectImages.length - 1){
                    onFinishUpload(imagePath)
                }
            },
            (error)=>{ notifyCx.showNotify("Something wrong upload image", error.message, 2) })
        }
    }

    useEffect(()=>{
        setOfficePhone(localStorage.getItem("officePhone"))
        fetchServiceList()
        return(()=>{

        })
    },[])

    return (
        <div id="inform-service">
            { isLoading ? <Loading/>: null }
            <HeaderTitle title={lang.service_inform} isShowBack backTo="/"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        onSubmit()
                    }}>
                        <Form.Group>
                            <Form.Label>{repairLang.service_type}</Form.Label>
                            <Form.Control as="select"
                            isInvalid={isError && !selectServicetype}
                            value={selectServicetype}
                            onChange={(e)=>{
                                let val = e.target.value
                                setSelectServicetype(val)
                                setSelectIssuetype("")
                                setArea("")
                                setQuantity("")
                                if(val !== ""){
                                    fetchIssueType(val)
                                }else{
                                    setSelectIssuetype("")
                                }
                            }}>
                                <option value="">{repairLang.choose_service_type}</option>
                                { serviceTypeList.map((item, key) =>
                                <option key={key} value={item.value}>
                                    {item.label}
                                </option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{repairLang.issue_type}</Form.Label>
                            <Form.Control as="select"
                            disabled={!selectServicetype}
                            isInvalid={isError && !selectIssuetype}
                            value={selectIssuetype}
                            onChange={(e)=>{
                                let val = e.target.value
                                setSelectIssuetype(val)
                            }}
                            >
                                <option value="">{repairLang.choose_issue_type}</option>
                                { issueTypeList.map((item, key) =>
                                <option value={item.value} key={key}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        { (selectIssuetype >= 1 && selectIssuetype <= 4) ?
                        <>
                        <Form.Group>
                            <Form.Label>{repairLang.quantity}</Form.Label>
                            <Form.Control
                            type="number"
                            isInvalid={isError && !quantity}
                            value={quantity}
                            onChange={(e)=>setQuantity(e.target.value)}
                            min={0}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{repairLang.Area}</Form.Label>
                            <Form.Control 
                            value={area}
                            isInvalid={isError && !area}
                            onChange={(e)=>setArea(e.target.value)}
                            as="select">
                                <option value="">{repairLang.choose_area}</option>
                                { areaItem.map((item, key) =>
                                <option value={item.id} key={key}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        </>
                        : null
                        }
                        { selectIssuetype === "8" ?
                         <Form.Group>
                            <Form.Label>{repairLang.telephone_affect}</Form.Label>
                            <Form.Control
                            value={telephone}
                            isInvalid={isError && !telephone}
                            onChange={(e)=>setTelephone(e.target.value)}
                            />
                        </Form.Group>
                        : null
                        }
                        { (selectIssuetype >= 14 && selectIssuetype <= 21) || (selectIssuetype >= 25 && selectIssuetype <= 28) ?
                        <Form.Group>
                            <Form.Label>{repairLang.Area}</Form.Label>
                            <Form.Control 
                            isInvalid={isError && !area}
                            value={area}
                            onChange={(e)=>setArea(e.target.value)}
                            as="select">
                                <option value="">{repairLang.choose_area}</option>
                                { genderItem.map((item, key) => 
                                <option value={item.value} key={key}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        : null
                        }
                        { selectIssuetype === "21" || selectIssuetype === "25" ?
                        <Form.Group>
                            <Form.Label>{repairLang.quantity}</Form.Label>
                            <Form.Control
                            isInvalid={isError && !quantity}
                            value={quantity}
                            onChange={(e)=>setQuantity(e.target.value)}
                            />
                        </Form.Group>
                        : null
                        }
                        <Form.Group>
                            <Form.Label>{repairLang.detail}</Form.Label>
                            <Form.Control
                            value={remark}
                            onChange={(e)=>setRemark(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{repairLang.office_phone}</Form.Label>
                            <Form.Control
                            isInvalid={isError && !officePhone}
                            value={officePhone}
                            onChange={(e)=>setOfficePhone(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{repairLang.floor}</Form.Label>
                            <Form.Control
                            isInvalid={isError && !floor}
                            value={floor}
                            onChange={(e)=>setFloor(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{repairLang.zone}</Form.Label>
                            <Form.Control
                            isInvalid={isError && !zone}
                            value={zone}
                            onChange={(e)=>setZone(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.images}</Form.Label>
                            <Form.File multiple accept="image/*"
                            onChange={(e)=>{
                                const imageFiles = e.target.files 
                                setSelectImages(imageFiles)
                            }}/>
                        </Form.Group>
                        <hr/>
                        <Button type="submit">
                            {lang.send}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default Inform
